import React from 'react';


function NotFound(props) {
	return (
		<div className="notFound">
			<h1>Page not found</h1>
		</div>
	);
}

export default NotFound;
